import React from 'react';
import { T } from '../shared/constants';
import MCQRenderer from './MCQRenderer';
import MultiRenderer from './MultiRenderer';
import OrderRenderer from './OrderRenderer';
import MatchRenderer from './MatchRenderer';
import HotTextRenderer from './HotTextRenderer';
import ShortRenderer from './ShortRenderer';
import InlineRenderer from './InlineRenderer';
import { itemType } from './naplanItems';

const RENDERERS = {
  multi: MultiRenderer,
  order: OrderRenderer,
  match: MatchRenderer,
  hottext: HotTextRenderer,
  short: ShortRenderer,
  inline: InlineRenderer,
};

/**
 * Renders any NAPLAN item type. Same props contract as MCQRenderer:
 * question, studentAnswer ({ questionType, rawAnswer, isCorrect, ... } | null),
 * state, showExplanation, onSubmit(studentAnswer), onAskLumi, onExplainVideo.
 * `rawAnswer` has the response shape from scripts/naplan-expand/ITEM_SCHEMA.md.
 */
export default function NaplanItemRenderer(props) {
  const { question } = props;
  const type = itemType(question);
  if (type === 'mcq') return <MCQRenderer {...props} />;
  const Renderer = RENDERERS[type];
  if (Renderer) return <Renderer {...props} />;
  if (Array.isArray(question?.options) && Number.isInteger(question?.answer)) return <MCQRenderer {...props} />;
  return (
    <div style={{ padding: "24px 32px", maxWidth: 860, margin: "0 auto", color: T.textMid, fontSize: 14 }}>
      This question can't be shown here. Skip to the next one.
    </div>
  );
}
